
import Currency from '~/mixins/Currency.js'
import ProductNumber from '~/mixins/ProductNumber.js'

export default {
  mixins: [Currency, ProductNumber],

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      quantity: this.product.quantity,
    }
  },

  computed: {
    productPrice() {
      return this.$auth.$state.priceInclTax
        ? this.product.gross_price_total
        : this.product.priceTotal
    },
  },

  watch: {
    product: {
      handler() {
        this.quantity = this.product.quantity
      },

      deep: true,
      immediate: true,
    },
  },

  methods: {
    async increment() {
      this.isLoading = true

      // check if quantity is not greater than 9999
      if (this.quantity + 1 > 9999) {
        this.isLoading = false
        return
      }

      await this.$store.dispatch(
        'cart/incrementQuantity',
        this.product.entry_id
      )

      this.isLoading = false
    },

    async decrement() {
      this.isLoading = true

      await this.$store.dispatch(
        'cart/decrementQuantity',
        this.product.entry_id
      )

      this.isLoading = false
    },

    async setQuantity(quantity) {
      this.isLoading = true

      // check if quantity is a number an not zero
      if (!parseInt(quantity)) {
        quantity = 1
      }

      // check if quantity is not greater than 9999
      if (quantity > 9999) {
        quantity = 9999
      }

      if (quantity && quantity !== '0') {
        this.quantity = quantity
        await this.$store.dispatch('cart/setQuantity', {
          quantity,
          entryId: this.product.entry_id,
        })
      }

      this.isLoading = false
    },

    async remove() {
      this.isLoading = true

      await this.$store.dispatch('cart/remove', this.product.entry_id)

      this.isLoading = false
    },
  },
}
